export const CHART_OPTIONS = {
    colors: [
        '#F3DBF1',
        '#E9BEE3',
        '#DB97D2',
        '#C76EBA',
        '#AD509E',
        '#8C3F7D',
        '#733567',
        '#733567'
    ],
    lang: { noData: 'No data to display' },
    noData: {
        style: {
            fontWeight: 'bold',
            fontSize: '15px',
            color: '#303030'
        }
    },
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false
    },
    title: { text: null },
    subtitle: { text: null },
    exporting: { enabled: false },
    credits: { enabled: false },
    tooltip: {
        useHTML: true,
        backgroundColor: '#000',
        style: {
            color: '#fff',
            fontSize: '10px'
        },
        formatter: function () {
            return `<b>${this.key}</b>: ${this.y}% <br>`;
        }
    },
    legend: {
        useHTML: true,
        layout: 'vertical',
        verticalAlign: 'bottom',
        itemStyle: {
            color: '#667085',
            fontWeight: 400,
            fontSize: '12px'
        },
        labelFormatter() {
            return `${this.options.name} ${this.options.y + '%'}`;
        }
    },
    plotOptions: {
        pie: {
            shadow: false,
            borderWidth: 0,
            allowPointSelect: false,
            size: '100%',
            dataLabels: { enabled: false }
        }
    },
    series: [
        {
            name: 'Physician Engagement Segments',
            data: [
                {
                    name: 'Segment A',
                    y: 19.77
                },
                {
                    name: 'Segment B',
                    y: 27
                },
                {
                    name: 'Segment C',
                    y: 7.98
                },
                {
                    name: 'Segment D',
                    y: 12.17
                },
                {
                    name: 'Segment E',
                    y: 3.8
                },
                {
                    name: 'Infectious Disease Specialist',
                    y: 4.94
                },
                {
                    name: 'Primary HIV HCP',
                    y: 17.11
                },
                {
                    name: 'Not Available',
                    y: 5.32
                }
            ],
            size: '100%',
            innerSize: '50%',
            showInLegend: true,
            borderRadius: 0
        }
    ]
};

export const DONUT_CHART_OPTIONS = {
    chart: { type: 'donut' },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    stroke: { show: false },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50
            }
        }
    },
    colors: ['#F3DBF1', '#E9BEE3', '#DB97D2', '#C76EBA', '#AD509E', '#8C3F7D', '#733567', '#733567'],
    legend: {
        show: false,
        showForSingleSeries: true,
        position: 'bottom',
        horizontalAlign: 'center', 
        verticalAlign: 'middle',
        fontSize: '12px'
    },
    dataLabels: { enabled: false },
    tooltip: {
        fillSeriesColor: false,
        theme: 'dark',
        y: {
            formatter: function (value, {
                series, seriesIndex, dataPointIndex 
            }) {
                return `${value}%`;
            }
        }     
    }
};

export const BAR_CHART_OPTIONS = {
    chart: {
        stacked: true,
        toolbar: { show: false }
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
            color: '#000000',
            fontSize: '14px'
        }
    },
    grid: { show: true },
    legend: {
        show: true,
        horizontalAlign: 'center',
        position: 'top'
    },
    xaxis: {
        title: {
            text: 'Deciles',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-xaxis-title'
            }
        },
        labels: { show: true },
        categories: [
            '0', '1', '2', '3',
            '4', '5', '6', '7',
            '8', '9', '10'
        ]
    },
    yaxis: {
        title: {
            text: 'Physician Engaged(%)',
            style: {
                color: '#667085',
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 500,
                cssClass: 'apexcharts-yaxis-title'
            }
        },
        labels: {
            formatter: (value) => value,
            style: {
                colors: ['#667085'],
                fontSize: '12px',
                fontFamily: 'Inter',
                fontWeight: 400,
                cssClass: 'apexcharts-yaxis-label'
            }
        },
        max: 100
    },
    dataLabels: { enabled: false },
    colors: ['#AD509E', '#E9BEE3'],
    plotOptions: {
        bar: {
            horizontal: false,
            borderRadius: 4
        }
    },
    tooltip: {
        y: {
            formatter: function (value) {
                return value + '%';
            }
        }
    }
};
